export class NudgeMode {
    static readonly basic = 'simple';
    static readonly advanced = 'complex';
    static readonly donation = 'donation';
    static readonly jobs = 'jobs'
}

